module.exports = __webpack_public_path__ + "img/big_1_59.1f367c12.png";